import React from 'react';
import { Button } from './button';
import { cn } from '../../lib/utils';

const EmptyState = ({
  icon: Icon,
  title = "No data available",
  description = "There's nothing to show here yet.",
  action,
  actionLabel,
  onAction,
  className = ""
}) => {
  return (
    <div className={cn("flex flex-col items-center justify-center py-12 px-4 text-center", className)}>
      {Icon && (
        <div className="mb-4">
          <Icon className="h-12 w-12 text-muted-foreground" />
        </div>
      )}
      
      <h3 className="text-lg font-semibold text-foreground mb-2">
        {title}
      </h3>
      
      {description && (
        <p className="text-muted-foreground mb-6 max-w-sm">
          {description}
        </p>
      )}
      
      {action && (
        <Button onClick={onAction}>
          {actionLabel || "Get Started"}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
